<!--  -->
<template>
  <div>
    <div v-loading="loadingtable" class="tactics_box">
      <el-form label-position="right" label-width="100px">
        <el-form-item label="群发标题">
          <el-input v-model="sp_strategy_title" placeholder="请输入策略标题" class="stra_box" />
        </el-form-item>
        <el-form-item label="群发类型">
          <el-radio-group v-model="sp_strategy_type" @change="spchanger">
            <!-- <el-radio-button :label="1" :disabled="type === 2 || type === 3">欢迎语</el-radio-button> -->
            <el-radio-button :label="2">定时</el-radio-button>
            <!-- <el-radio-button :label="3">循环</el-radio-button> -->
            <!-- <el-radio-button :label="4" :disabled="type === 2 || type === 3">关键词</el-radio-button> -->
          </el-radio-group>
        </el-form-item>
        <el-form-item label="发送对象类型">
          <el-radio-group v-model="group_selection" @change="sendmatgser">
            <el-radio-button :label="1" :disabled="type == 2">默认客户</el-radio-button>
            <!-- <el-radio-button :label="2" :disabled="type === 2">从群中选择</el-radio-button> -->
            <el-radio-button :label="3" :disabled="type == 2">设置群</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="发送方式">
          <el-radio-group v-model="push_method" @change="spchangerr">
            <el-radio-button :label="1" :disabled="type == 2 || group_selection === 3">官方接口</el-radio-button>
            <el-radio-button :label="2" :disabled="type == 2">第三方接口</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <div class="copy_box">
          <div class="ca_boxre">时间</div>
          <el-date-picker
            v-model="sendtime"
            :picker-options="pickerOptions"
            :clearable="false"
            type="datetime"
            placeholder="选择日期时间"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
          />
        </div>
        <div class="copy_boxr" style="margin-bottom:20px">
          <div class="ca_boxre">消息</div>
          <div>
            <el-tag v-if="sp_message_no!=''" style="margin-right:10px">{{ title }} ( {{ sp_message_no }} )</el-tag>
            <el-button size="mini" type="warning" icon="el-icon-s-promotion" @click="chooserr">选择消息</el-button>
            <el-button v-if="sp_message_no!=''" size="mini" type="primary" icon="el-icon-pie-chart" @click="look(sp_message_no)">预览</el-button>
          </div>
        </div>
        <el-form-item v-if="editarr.length !== 0 && group_selection === 1" label="员工">
          <el-tag v-for="item,index in editarr" :key="index" style="margin-right:10px">{{ item.name }} ( {{ item.corp_name }} )</el-tag>
        </el-form-item>
        <!-- type === 2 -->
        <el-form-item v-if="editarr.length !== 0 && group_selection === 3" label="群聊">
          <el-tag v-for="item,index in editarr" :key="index" style="margin-right:10px">{{ item.group_chat_name }} ( {{ item.group_chat_id }} )</el-tag>
        </el-form-item>
        <!-- <el-form-item v-if="type === null && group_selection === 1" label="选中员工">
          <el-tag v-for="item,index in people" :key="index" style="margin-right:10px">{{ item.name }} ( {{ item.corp_name }} )</el-tag>
        </el-form-item>
        <el-form-item v-if="type === null && group_selection === 3" label="选中群聊">
          <el-tag v-for="item,index in group" :key="index" style="margin-right:10px">{{ item.group_chat_name }} ( {{ item.group_chat_id }} )</el-tag>
        </el-form-item> -->
      </el-form>
      <peorlist v-show="group_selection === 1" ref="peorlistview" class="mg-6" @callabck="callabck" />
      <grouplist v-show="group_selection === 3" ref="grouplistview" class="mg-6" @gruonpidcallabck="gruonpidcallabck" />
      <div class="sava_box">
        <el-button type="primary" @click="goback">返回</el-button>
        <el-button v-if="type != 2" type="warning" @click="saveclick">保存</el-button>
      </div>
    </div>
    <el-dialog
      title="选择消息"
      :visible.sync="dialogVisible"
      :destroy-on-close="true"
      width="55%"
    >
      <choosetactics ref="choosetacticsview" @callbackr="callbackr" />
    </el-dialog>
    <!-- 预览标签组弹窗 -->
    <el-dialog
      title="预览"
      :visible.sync="priwdialogVisible"
      :modal-append-to-body="false"
      :append-to-body="true"
      width="25%"
    >
      <previewdialog ref="timepreview" />
    </el-dialog>
  </div>
</template>

<script>
import choosetactics from '../../enterprisemilist/components/choosetactics.vue'
import previewdialog from '../../enterpmessagelist/components/previewdialog.vue'
import { temporaryPushtimingPushInfo, temporaryPushstore, temporaryPushupdate } from '@/api/officialaccount.js'
import peorlist from './peorlist.vue'
import grouplist from './grouplist.vue'
import { sprEnterprise } from '@/api/officialaccount.js'
export default {
  components: { choosetactics, previewdialog, peorlist, grouplist },
  data() {
    return {
      loadingtable: false,
      sp_strategy_title: '',
      sp_strategy_type: 2,
      group_selection: 1,
      push_method: 1,
      houroptions: [],
      minutesoptions: [],
      sendtime: null, // 发送时间
      pickerOptions: { // 禁用当前日期之前的日期
        disabledDate(time) {
          // Date.now()是javascript中的内置函数，它返回自1970年1月1日00:00:00 UTC以来经过的毫秒数。
          return time.getTime() < Date.now() - 8.64e7
        }
      },
      title: '',
      sp_message_no: '',
      dialogVisible: false,
      priwdialogVisible: false,
      type: null,
      ids: null,
      people: [],
      group: [],
      peoplechaun: [],
      groupchuan: [],
      fuarr: [],
      editarr: []
    }
  },
  created() {
    // eslint-disable-next-line eqeqeq
    if (JSON.stringify(this.$route.query) == '{}') {
      this.ids = null
      this.$nextTick(() => {
        this.$refs.peorlistview.sendr([], this.type)
        this.$refs.grouplistview.sendr([], this.type)
      })
      console.log('this.$route.query.type', this.$route.query.type)
    } else {
      this.ids = this.$route.query.id
      this.type = this.$route.query.type
      this.multiplexlist()
      console.log('this.$route.query.type', this.$route.query.type)
    }
    this.inittimearr(0, 23, this.houroptions)
    this.inittimearr(0, 59, this.minutesoptions)
  },
  mounted() {

  },
  methods: {
    // 复用请求
    async multiplexlist() {
      const data = await temporaryPushtimingPushInfo({
        sp_temporary_no: this.ids
      })
      this.sp_strategy_title = data.data.temporary_push_data.sp_temporary_title
      this.group_selection = data.data.temporary_push_data.group_selection
      this.push_method = data.data.temporary_push_data.push_method
      this.sendtime = data.data.temporary_push_data.send_time
      this.title = data.data.msg_data.message_name
      this.sp_message_no = data.data.msg_data.sp_message_no
      this.editarr = data.data.bind_info
      this.fuarr = []
      if (data.data.temporary_push_data.group_selection === 1) {
        this.fuarr = data.data.bind_info.map((item) => {
          return { employee_no: item.employee_no }
        })
        console.log(' this.fuarr', this.fuarr, data.data.bind_info)
        this.$nextTick(() => {
          // this.$refs.peorlistview.sendr(this.fuarr, this.type)
          this.$refs.peorlistview.sendr(data.data.bind_info, this.type)
        })
        this.people = data.data.bind_info
      }
      if (data.data.temporary_push_data.group_selection === 3) {
        this.fuarr = data.data.bind_info.map((item) => {
          return { group_chat_id: item.group_chat_id }
        })
        this.$nextTick(() => {
          this.$refs.grouplistview.sendr(data.data.bind_info, this.type)
        })
        this.group = data.data.bind_info
      }

      console.log('data', data.data)
    },
    // 初始化时分秒
    inittimearr(valone, valtwo, arr) {
      for (let i = valone; i <= valtwo; i++) {
        arr.push({
          value: i,
          label: `${i}`
        })
      }
    },
    dayewr() {
      // eslint-disable-next-line eqeqeq
      if (this.day_of_month < 1 && this.day_of_month != '') {
        this.day_of_month = 1
      }
      // 判断不能输入小数点
      const str = '' + this.day_of_month
      if (str.indexOf('.') !== -1) {
        console.log('小鼠了')
        this.day_of_month = 0
      }
      if (this.day_of_month > 31) {
        this.day_of_month = 31
      }
    },
    chooserr() {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.choosetacticsview.send(2, this.push_method)
      })
    },
    callbackr(item) {
      this.dialogVisible = false
      this.sp_message_no = item.sp_message_no
      this.title = item.title
    },
    async look(id) {
      const data = await sprEnterprise({
        sp_message_no: id
      })
      console.log('data', data.data)
      this.priwdialogVisible = true
      setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.timepreview.send(data.data)
      }, 100)
    },
    callabck(arr) {
      this.people = []
      this.people = arr
      console.log('callback', arr)
    },
    gruonpidcallabck(arr) {
      this.group = []
      this.group = arr
      console.log('gruonpidcallabck', arr)
    },
    goback() {
      this.$router.go(-1)
    },
    async saveclick() {
      if (this.sp_strategy_title === '') {
        this.$message.error('请填写群发标题')
        return
      }
      if (this.sendtime === null) {
        this.$message.error('请选择时间')
        return
      }
      if (this.sp_message_no === '') {
        this.$message.error('请选择消息')
        return
      }
      if (this.group_selection === 1) {
        if (this.people.length === 0) {
          this.$message.error('请选择员工')
          return
        }
      }
      if (this.group_selection === 3) {
        if (this.group.length === 0) {
          this.$message.error('请选择群聊')
          return
        }
      }
      // eslint-disable-next-line eqeqeq
      if (this.type == 2) {
        console.log('编辑')
        const data = await temporaryPushupdate({
          sp_temporary_no: this.ids,
          sp_temporary_title: this.sp_strategy_title,
          send_time: this.sendtime,
          sp_message_no: this.sp_message_no
        })
        console.log('data', data)
        this.$router.go(-1)
      } else {
        this.peoplechaun = this.people.map((itemr, indexrs) => {
        // eslint-disable-next-line eqeqeq
          return itemr.employee_no
        })
        this.groupchuan = this.group.map((itemr, indexrs) => {
        // eslint-disable-next-line eqeqeq
          return itemr.group_chat_id
        })
        const data = await temporaryPushstore({
          sp_temporary_title: this.sp_strategy_title,
          group_selection: this.group_selection,
          push_method: this.push_method,
          send_time: this.sendtime,
          sp_message_no: this.sp_message_no,
          relation_ids: this.group_selection === 1 ? this.peoplechaun : this.groupchuan
        })
        this.$router.go(-1)
        console.log('data', data)
      }
    },
    spchanger(val) {
      console.log(val)
    },
    sendmatgser(val) {
      console.log(val)
      if (val === 3) {
        this.push_method = 2
      }
      this.sp_message_no = ''
      this.title = ''
    },
    spchangerr(val) {
      console.log(val)
      this.sp_message_no = ''
      this.title = ''
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.tactics_box{
  padding: 20px;
}
.stra_box{
  width: 300px;
}
.copy_box{
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  padding-left: 34px;
}
  .ca_boxre{
    width: 50px;
    text-align: right;
    margin-right:16px;
    color: rgb(169, 162, 151);
    font-size: 14px;
    font-weight: 700;
  }
  .taewr{
  display: flex;
  align-items: center;
  }
  .tiwmebox{
  width: 50px;
  background: #f4f7f7;
  height: 36px;
  border: 1px solid #cccccc;
  border-left: 0px;
  text-align: center;
  line-height: 36px;
  color: #61686b;
  border-radius: 0px 5px 5px 0px;
  }
  .copy_boxr{
  display: flex;
  align-items: center;
  padding-left: 34px;
}
  .ca_boxre{
    width: 50px;
    text-align: right;
    margin-right:16px;
    color: rgb(169, 162, 151);
    font-size: 14px;
    font-weight: 700;
  }
 ::v-deep input::-webkit-outer-spin-button,
  ::v-deep input::-webkit-inner-spin-button {
    -webkit-appearance: none !important;
  }
  ::v-deep input[type='number'] {
    -moz-appearance: textfield !important;
    }
        .sava_box{
      position: fixed;
      bottom: 10px;
      left: 286px;
      z-index: 1;
    }

.tactics_box .el-form-item--medium .el-form-item__label{
  line-height:36px !important;
}
.mg-6{
  margin-left:60px
}
@media (max-width: 768px){
  .el-form-item__label{
    line-height:36px !important;
  }
  .mg-6{
    margin:0px;
  }
}
</style>
